export default "__VITE_ASSET__Sqp9W6iA__"